var e = /* @__PURE__ */ ((o) => (o.VIEWED = "sdk_viewed", o.CATEGORY_SELECTED = "category_selected", o.SCORE_EXPANDED = "score_expanded", o.SCORE_POI_SELECTED = "score_poi_selected", o.POI_CALCULATE_ROUTE = "poi_calculate_route", o.MAP_POI_SELECTED = "map_poi_selected", o.SEARCH_CALCULATE_ROUTE = "search_calculate_route", o))(e || {});
const c = {
  "local-content": "LocalContentSDK",
  "local-demographics": "LocalDemographicsSDK",
  "local-profiles": "",
  neighborhoodintel: "",
  "local-neighborhood-hero": "",
  "local-neighbourhood-map": "",
  "local-neighborhood-characteristics": "",
  "local-neighborhood-highlights": "",
  "local-neighborhood-demographics": ""
};
export {
  e as AnalyticsEvents,
  c as MixpanelProducts
};
